import $i18n from '@/locales/i18n';
import Icon from './logo';
const CnLayoutContentPrototype = {
    title: $i18n.get({ id: 'PageContent', dm: '页面内容' }),
    componentName: 'CnLayoutContent',
    icon: Icon,
    docUrl: '',
    isContainer: true,
    canOperating: false,
    configure: [
        {
            name: 'isCnLayoutContent',
            title: 'CnLayoutContent',
            initialValue: true,
            display: 'none',
        },
        {
            name: '_context',
            title: $i18n.get({ id: 'Context', dm: '上下文' }),
            initialValue: {
                type: 'JSExpression',
                value: 'this',
            },
            display: 'none',
        },
    ],
};
// 原型配置请参考：https://lark.alipay.com/vision/docs/prototype
export { CnLayoutContentPrototype };
